import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-invalid-credentials',
  templateUrl: './invalid-credentials.component.html',
  styleUrls: ['./invalid-credentials.component.scss']
})
export class InvalidCredentialsComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<InvalidCredentialsComponent>) { }

  ngOnInit(): void {
  }
  
  closeDialog() {
    this.dialogRef.close(); // This will close the dialog when called
  }
}
